import { RESET_UPDATE_TO_NEW_BOOKING, UPDATE_TO_NEW_BOOKING_FAILURE, UPDATE_TO_NEW_BOOKING_REQUEST, UPDATE_TO_NEW_BOOKING_SUCCESS } from "../actions/cancelActions";

const initialState = {
    cancelledBookings: [],
    cancelLoading: false,
    cancelData: null,
    cancelError: null,
};

const bookingReducer = (
    state = initialState,
    action: any
) => {
    switch (action.type) {

        case "GET_CANCEL_BY_DATE_REQUEST":
            return {
                ...state,
                cancelLoading: true,
            };

        case "GET_CANCEL_BY_DATE_SUCCESS":
            return {
                ...state,
                cancelLoading: false,
                cancelledBookings: action.payload,
            };

        case "GET_CANCEL_BY_DATE_FAILURE":
            return {
                ...state,
                cancelLoading: false,
            };

        case UPDATE_TO_NEW_BOOKING_REQUEST:
            return {
                ...state,
                loading: true,
                success: false,
                message: null,
                error: null,
            };

        case UPDATE_TO_NEW_BOOKING_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                message: action.payload.message,
                error: null,
            };

        case UPDATE_TO_NEW_BOOKING_FAILURE:
            return {
                ...state,
                loading: false,
                success: false,
                message: null,
                error: action.payload,
            };

        case RESET_UPDATE_TO_NEW_BOOKING:
            return initialState;

        default:
            return state;
    }
};

export default bookingReducer;